import Vue from 'vue'
import FileChatMessage from '@/models-ts/chat/messages/FileChatMessage'
import { humanizeBytes } from '@/utils-ts/strings'
import { formatDate } from '@/utils/date'
import messageMixin from '../messageMixin'

export default Vue.extend({
  mixins: [messageMixin],
  props: {
    message: FileChatMessage,
  },
  computed: {
    isSending() {
      return this.message.sending
    },
    size() {
      return humanizeBytes(this.message.body.size)
    },
    date() {
      return formatDate(this.message.createdAt, 'MMM DD, HH:mm')
    },
  },
})
